import * as z from 'zod';

const SingleTeamInfoApiSchema = z.object({
  name: z.string(),
  jersey: z.string(),
  is_national_team: z.boolean().optional().default(false),
});

export default SingleTeamInfoApiSchema;
